import React, { useCallback } from 'react';

import { MdCancel } from 'react-icons/md';

import { personNameBuilder } from '@modules/utils';
import { Col, PersonAvatar, Row, S, Tag } from '@shared/components';

import styles from './Person.less';

type Props = {
  data: {
    firstName: string;
    lastName: string;
    middleName: string;
    nickName: string;
    isAdult: boolean;
    gender?: string;
    userId: string;
  };
  onClose: (userId: string) => void;
};

const Person: React.FC<Props> = ({ data, onClose }) => {
  const { isAdult, userId, gender } = data;

  const handleClose = useCallback(() => {
    onClose(userId);
  }, [onClose, userId]);

  const personName = personNameBuilder.short(data);

  return (
    <Tag className={styles.tag} outline={false}>
      <Row type="flex" align="middle">
        <Col>
          <PersonAvatar isAdult={isAdult} gender={gender} />
        </Col>
        <Col className={styles.personName}>
          <S size={'3'}>{personName}</S>
        </Col>
        <Col className={styles.closeIcon}>
          <div onClick={handleClose}>
            <MdCancel />
          </div>
        </Col>
      </Row>
    </Tag>
  );
};

export default Person;
